import ReportsScreen from './components/ReportsScreen'

export default {
  path: '/reporta',
  name: 'Reports',
  component: ReportsScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Reports/index.js